import { dlTrackEvent } from "components/dataLayer/dataLayer";
import { useSession } from "contexts/session-context"
import { Link } from "react-router-dom";

const SolMezclasId = () => {
  const [session] = useSession()
  const sumasixProvider = session.user?.profileLinkings?.some((profile) => profile.provider === "SumaSix");

  const handleClickRanking = () => {
    dlTrackEvent('user_interaction', {
      action: 'click',
      element: 'HOME :: Ir a ranking',
      section: 'HOME'
    })
  }

  const handleClickLinking = () => {
    dlTrackEvent('user_interaction', {
      action: 'click',
      element: 'HOME :: Ir a vincular cuenta',
      section: 'HOME'
    })
  }

  if (sumasixProvider) {
    return (
      <Link to={'/ranking'} onClick={handleClickRanking}>
        <img src={`${AZURE_BASE_URL}/boton_cuenta_vinculada-ver-ranking.webp`} className='w-full' />
      </Link>
    )
  }

  return (
    <Link to={'/sumasix'} onClick={handleClickLinking}>
      <img src={`${AZURE_BASE_URL}/boton_vincular_cuenta.webp`} className='w-full' />
    </Link>
  )
}

export default SolMezclasId

